import { parseMaintenanceStatus, type IMaintenanceStatus } from '@featit/shared/maintenance';

export const MAINTENANCE_STATUS_EVENT = 'featit:maintenance-status';

export function publishMaintenanceStatus(value: unknown): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent<IMaintenanceStatus | null>(MAINTENANCE_STATUS_EVENT, {
      detail: value === null ? null : parseMaintenanceStatus(value),
    }),
  );
}
